// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"22":"859d8e7b","118":"f6940c79","327":"212d1b23","358":"31786e00","431":"7e7a4bed","473":"a28f39a8","518":"b7d52d07","761":"dcdc8847","765":"5452b78e","779":"41da648c"}[chunkId] + ".js";
};